import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import {
    ContractListComponent,
    ContractSelectComponent,
    ContractWidgetContainerComponent,
    PageHeaderComponent,
} from '../../components';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, switchMap } from 'rxjs';
import { Contract } from '@models/contract';
import { ContractsService } from '../../contracts.service';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';

@Component({
    selector: 'app-contract-detail-view',
    imports: [
        ContractWidgetContainerComponent,
        ContractSelectComponent,
        ContractListComponent,
        RouterModule,
        CtrlIconComponent,
        PageHeaderComponent,
    ],
    templateUrl: './contract-detail-view.component.html',
    styleUrl: './contract-detail-view.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractDetailViewComponent {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private contractService = inject(ContractsService);

    protected contracts = toSignal(this.contractService.contracts$);

    protected contract = toSignal(
        this.route.params.pipe(
            map((params: Params) => params.contractId ?? null),
            switchMap((contractId: string) => this.contractService.get(parseInt(contractId, 10))),
        ),
    );

    protected otherContracts = computed(() =>
        this.contracts().filter((item: Contract) => item.id !== this.contract().id),
    );

    protected handleClickDamageReport(): void {
        this.router.navigate(['/', 'portal', 'schaden-melden', this.contract().id, 'beschreibung']);
    }

    protected handleContractSelect(contract: Contract): void {
        this.router.navigate(['..', contract.id], { relativeTo: this.route });
    }
}
